import { render, staticRenderFns } from "./Profileuser.vue?vue&type=template&id=5ec979a2&scoped=true&"
import script from "./Profileuser.vue?vue&type=script&lang=js&"
export * from "./Profileuser.vue?vue&type=script&lang=js&"
import style0 from "./Profileuser.vue?vue&type=style&index=0&id=5ec979a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec979a2",
  null
  
)

export default component.exports